import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/custom-validators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm:FormGroup;
  public errorMessages:any=null;
  public loggingIn:boolean=false;
  constructor(private authenticationService: AuthenticationService, private router: Router) {
    this.loginForm = new FormGroup({
      email: new FormControl('',[Validators.required,CustomValidators.validateEmailAddress]),
      password: new FormControl('',[Validators.required,CustomValidators.validateTextField]),
    });
  }

  ngOnInit() {
  }

  login(){
    this.errorMessages = null;
    this.loggingIn = true;
    var email = this.loginForm.get('email').value;
    var password = this.loginForm.get('password').value;
    this.authenticationService.login(email, password).subscribe(res => {
      if(res.user.role.name!='admin'){
        this.loggingIn = false;
        this.errorMessages = 'This user does not have access to the Administration Portal';
      }
      else{
        this.loggingIn = false;
        this.authenticationService.storeLogin(res);
        this.router.navigate(['/courses']);
      }

    },
    res => {
      this.errorMessages = 'Invalid username or password';
      this.loggingIn = false;
    });
  }
}
